import { initGrowthbookPlugin } from '@academica-box/plugins/growthbook.client'

export default defineNuxtPlugin(initGrowthbookPlugin)
